import { Locale } from '@cars4ever/public-ui';

import IFieldConfig from '../types/IFieldConfig';

import { zipMask } from './masksConfigMap';

const zipCodeConfigMap: Record<Locale, IFieldConfig> = {
  [Locale.DK]: {
    inputProps: {
      mask: zipMask as never,
      type: 'integer',
    },
    validate: (value?: string): boolean => value?.length === 4,
  },
  [Locale.SE]: {
    inputProps: {
      mask: zipMask as never,
      type: 'integer',
    },
    validate: (value?: string): boolean => value?.length === 5,
  },
};

export default zipCodeConfigMap;
